import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { useGetCurrencies, useUpdateCurrency } from "../../../../api/currency";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
} from "../../../../components/Component";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import LoadingSpinner from "../../../components/spinner";
import Search from "../tables/Search";
import SortToolTip from "../tables/SortTooltip";
import EditCurrencyModal from "./editModal";

const CurrencyManagementPage = () => {
  const [searchParams] = useSearchParams();

  const itemsPerPage = searchParams.get("limit") ?? 100;
  const currentPage = searchParams.get("page") ?? 1;
  const search = searchParams.get("search") ?? "";

  // const { isLoading, data, error } = useGetAllProducts(currentPage, itemsPerPage, search, type);
  const { isLoading, data } = useGetCurrencies(currentPage, itemsPerPage, search);
  const { mutate, isSuccess } = useUpdateCurrency();
  const [formData, setFormData] = useState({
    currencyID: "",
    fabstouchRate: "",
  });
  const [isOpen, setIsOpen] = useState("");

  const [oldAmount, setOldAmount] = useState("");

  const [onSearch, setonSearch] = useState(false);
  // console.log(data);

  const onEditClick = (id) => {
    // console.log(id);
    data.forEach((item) => {
      if (item.id === id) {
        setFormData({ ...formData, currencyID: id, fabstouchRate: item?.fabstouchRate?.toFixed(2) });
        setOldAmount(item.exchangeRateInNGN?.toFixed(2));
        setIsOpen(true);
      }
    });
  };

  const formSubmit = () => {
    mutate(formData);
  };

  useEffect(() => {
    if (isSuccess) {
      setIsOpen(false);
      setFormData({ currencyID: "", fabstouchRate: "" });
    }
  }, [isSuccess]);
  // function to filter data
  // const filterData = useCallback(() => {
  //   return;
  // }, []);

  // Change Page
  //paginate

  //scroll off when sidebar shows
  // useEffect(() => {
  //   view.add ? document.body.classList.add("toggle-shown") : document.body.classList.remove("toggle-shown");
  // }, [view.add]);

  return (
    <React.Fragment>
      <Head title="Currency"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Currency</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {/* PRODUCT TABLE HERE */}
        <Block>
          <Card>
            <div className="card-inner border-bottom">
              <div className="card-title-group">
                <div className="card-title">
                  <h5 className="title">All Currency</h5>
                </div>
                <div className="card-tools me-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <Button
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setonSearch(true);
                        }}
                        className="btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </Button>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    {/* <li>
                      <FilterOptions options={countriesFilterOptions} />
                    </li> */}
                    <li>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                          <Icon name="setting"></Icon>
                        </DropdownToggle>
                        <DropdownMenu end className="dropdown-menu-xs">
                          <SortToolTip />
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </li>
                  </ul>
                </div>
                {/* Search component */}
                <Search onSearch={onSearch} setonSearch={setonSearch} placeholder="name" />
              </div>
            </div>
            <div className="card-inner-group">
              <div className="card-inner p-0">
                {isLoading ? (
                  <LoadingSpinner />
                ) : data && data?.length > 0 ? (
                  <>
                    <DataTableBody className="is-compact">
                      <DataTableHead className="tb-tnx-head bg-white fw-bold text-secondary">
                        <DataTableRow>
                          <span className="tb-tnx-head bg-white text-secondary">S/N</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-tnx-head bg-white text-secondary">Currency Code</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-tnx-head bg-white text-secondary">Exchange Rate</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-tnx-head bg-white text-secondary">Naira Rate</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-tnx-head bg-white text-secondary">Fabstouch Rate</span>
                        </DataTableRow>

                        <DataTableRow className="nk-tb-col-tools">
                          <ul className="nk-tb-actions gx-1 my-n1">
                            <li className="me-n1">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  href="#toggle"
                                  onClick={(ev) => ev.preventDefault()}
                                  className="dropdown-toggle btn btn-icon btn-trigger disabled"
                                >
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableHead>
                      {data?.map((item, index) => {
                        return (
                          <DataTableItem key={item.id} className="text-secondary">
                            <DataTableRow>
                              <span> {index + 1}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <div className="user-name">
                                <span className="tb-lead ccap">{item?.symbol}</span>
                              </div>
                            </DataTableRow>

                            <DataTableRow>
                              <span>{item?.exchangeRate}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span>{item?.exchangeRateInNGN?.toFixed(2)}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span>{item?.fabstouchRate?.toFixed(2)}</span>
                            </DataTableRow>

                            <DataTableRow className="nk-tb-col-tools">
                              <ul className="nk-tb-actions gx-1 my-n1">
                                <li className="me-n1">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      tag="a"
                                      href="#more"
                                      onClick={(ev) => ev.preventDefault()}
                                      className="dropdown-toggle btn btn-icon btn-trigger"
                                    >
                                      <Icon name="more-h"></Icon>
                                    </DropdownToggle>
                                    <DropdownMenu end>
                                      <ul className="link-list-opt no-bdr">
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#edit"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              onEditClick(item.id);
                                            }}
                                          >
                                            <Icon name={"edit"}></Icon>
                                            <span>Edit Rate</span>
                                          </DropdownItem>
                                        </li>
                                      </ul>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            </DataTableRow>
                          </DataTableItem>
                        );
                      })}
                    </DataTableBody>
                  </>
                ) : (
                  <div className="text-center" style={{ paddingBlock: "1rem" }}>
                    <span className="text-silent">No record found</span>
                  </div>
                )}
              </div>
            </div>
          </Card>
        </Block>
      </Content>

      <EditCurrencyModal
        onSubmit={formSubmit}
        formData={formData}
        setFormData={setFormData}
        modal={isOpen}
        oldAmount={oldAmount}
        closeModal={() => setIsOpen(false)}
      />
    </React.Fragment>
  );
};

export default CurrencyManagementPage;
